<template>
  <div class="badge" :class="badgeClass">{{reservation.state}}</div>
</template>

<script>
export default {
  props: {
    reservation: Object
  },
  computed: {
    badgeClass() {
      if(this.reservation.state === 'canceled' || this.reservation.state === 'expired')
        return 'badge-danger'
      if(this.reservation.state === 'confirmed')
        return 'badge-success'
      if(this.reservation.state === 'requested')
        return 'badge-warning'
      return 'badge'
    }
  }
}
</script>
